import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { TireQuoteRecordCustomer } from '@navio/nsdk';
import { NoddiBasicCard, NoddiTabs } from 'noddi-ui-web';
import { getCarDisplayName, TireOfferTabs } from 'noddi-util';
import { getTabsTranslations } from '../../utils/commonTranslations';
import { StatusUpdates } from './StatusUpdates';
import { TireOfferStatusChip } from './TireOfferStatusChip';
import { TireOrderDetails } from './TireOrderDetails';

function getTabItems(tireOffer: TireQuoteRecordCustomer) {
  return [
    {
      label: t`Updates`,
      value: TireOfferTabs.STATUS_UPDATES,
      node: <StatusUpdates tireOffer={tireOffer} />
    },
    {
      label: t`Order details`,
      value: TireOfferTabs.ORDER_DETAILS,
      node: <TireOrderDetails tireOffer={tireOffer} />
    }
  ];
}

export const TireOfferStatusContent = ({ tireOffer }: { tireOffer: TireQuoteRecordCustomer }) => {
  const season = `${tireOffer.season.label.toLowerCase()} tires`;
  const carName = getCarDisplayName({ car: tireOffer.car, showYear: false });
  const translatedSeasonTitle = t`New ${season} for`;
  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-col md:flex-row md:gap-1 md:text-lg'>
        <p>{translatedSeasonTitle}</p>
        <p className='font-semibold'> {carName}</p>
      </div>
      <NoddiBasicCard className='p-0'>
        <div className='flex flex-wrap justify-between gap-4 border-b border-grey/30 px-5 py-4'>
          <p className='text-lg'>
            <Trans>Order status</Trans>
          </p>
          <TireOfferStatusChip tireOffer={tireOffer} />
        </div>

        <div className='flex flex-col gap-4 px-5 py-4'>
          <NoddiTabs<TireOfferTabs>
            tabItems={getTabItems(tireOffer)}
            defaultValue={TireOfferTabs.STATUS_UPDATES}
            translations={getTabsTranslations()}
          />
        </div>
      </NoddiBasicCard>
    </div>
  );
};
